import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '../ui/chart';

export type ShipmentsDatum = { week: string; inbound: number; outbound: number };

type SingleSeriesDatum = Record<string, string | number>;

export default function ShipmentsAreaChart({
  data,
  xDataKey = 'week',
  series,
}: {
  data: SingleSeriesDatum[];
  xDataKey?: string;
  series: { key: string; name: string; stroke: string; fill: string }[];
}) {
  return (
    <ChartContainer className="h-64">
      <ResponsiveContainer>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xDataKey} tick={{ fontSize: 11 }} />
          <YAxis />
          <Tooltip content={<ChartTooltipContent />} />
          {series.map(s => (
            <Area
              key={s.key}
              type="monotone"
              dataKey={s.key}
              stroke={s.stroke}
              fill={s.fill}
              name={s.name}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
}


